import { Injectable } from "@angular/core";
import { Observable } from "rxjs";


import { HttpClient } from '@angular/common/http';

 
@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
 

  constructor(private http: HttpClient) { }

  getCurrencies(Symbol:string): Observable<any> {
    return this.http.get(`https://v6.exchangerate-api.com/v6/49459475f0e132bd02480e12/latest/${Symbol}`);
  }
}
